import { z } from 'zod';
import { nullableUuidString, requiredUuidString } from '../zod-helpers/index.js';
export const addBomDefaultPartInputSchema = z.object({
    bomId: requiredUuidString('BOM is required.', 'Invalid BOM selection.'),
    partId: requiredUuidString('Part is required.', 'Invalid part selection.'),
    // setPartDefaultBom's reassignment token: omitted refuses to move the part off an active default; null means "shown as unclaimed"; a BOM id means "shown as that BOM's current holder".
    confirmedAgainstBomId: nullableUuidString('Invalid BOM confirmation.').optional(),
});
//# sourceMappingURL=add-default-part-input.js.map